import { customRandom, nanoid } from "nanoid"
import seedrandom from "seedrandom"
import { v5 } from "uuid"

const NAMESPACE = "1d671a64-4dd5-491e-93b0-da01ff1f3341"

// Same 64-char alphabet that nanoid uses, but we swap '+' => '$', '/' => '_'
const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789$_"

function deriveShortGuidFrom(...data) {
    let size = 14
    if (typeof data[0] === "number") {
        size = data.shift()
    }

    const seed = JSON.stringify(data, functionToString())
    const rng = seedrandom(seed)

    const random = (bytes) => {
        const out = new Uint8Array(bytes)
        for (let i = 0; i < bytes; i++) {
            out[i] = Math.floor(rng() * 256)
        }
        return out
    }

    const deterministicNanoId = customRandom(ALPHABET, size, random)
    let id = deterministicNanoId()
    if (/^[^A-Za-z$_]/.test(id)) {
        id = `_${id}`
    }
    return id
}

function functionToString() {
    const seen = new Set()
    return function replacer(_key, value) {
        if (seen.has(value)) return undefined
        if (typeof value === "object" && value !== null) {
            seen.add(value)
        }
        if (typeof value === "function") {
            return value.toString()
        }
        return value
    }
}

function deriveGuidFrom(...data) {
    return v5(JSON.stringify(data, functionToString()), NAMESPACE)
}

function generate(size = 14) {
    let id = nanoid(size)
    if (/^[^a-zA-Z$_]/.test(id)) {
        id = `_${id}`
    }
    return id.replace(/-/g, "__")
}

function makeRedisKey(coreName, ...data) {
    return `${coreName}:${deriveGuidFrom(14, ...data)}`
}

const guid = {
    generate,
    deriveGuidFrom,
    makeRedisKey,
    deriveShortGuidFrom,
}

export { generate, deriveGuidFrom, makeRedisKey, deriveShortGuidFrom }
export default guid
